import { render, staticRenderFns } from "./official_error.vue?vue&type=template&id=71235d4f&scoped=true&"
import script from "./official_error.vue?vue&type=script&lang=js&"
export * from "./official_error.vue?vue&type=script&lang=js&"
import style0 from "./official_error.vue?vue&type=style&index=0&id=71235d4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71235d4f",
  null
  
)

export default component.exports